/* global angular */
( function () {
	'use strict';

	function groupPager () {
		return {
			'restrict'         : 'A',
			'replace'          : true,
			'transclude'       : true,
			'controller'       : 'GroupPager',
			'controllerAs'     : 'vm',
			'bindToController' : true,
			'templateUrl'      : '/templates/components/group-pager/group-pager.html',
			'scope'            : {
				'collection'   : '=',
				'isValidFrm'   : '=',
				'showButton'   : '=',
				'templateView' : '=',
				'isScore'      : '=',
				'readOnly'     : '=',
				'hideScoring'  : '='
			}
		};
	}

	angular
		.module( 'app.components' )
		.directive( 'groupPager', groupPager );
} )( );
